import menu2Fill from "@iconify/icons-eva/menu-2-fill";
import { Icon } from "@iconify/react";
import { useNavigate, useLocation } from "react-router";
import PropTypes from "prop-types";
import {
  AppBar,
  Box,
  IconButton,
  Stack,
  Toolbar,
  Typography,
  Button,
} from "@material-ui/core";
import { alpha, styled, useTheme } from "@material-ui/core/styles";
import useCollapseDrawer from "../../hooks/useCollapseDrawer";
import useAuth from "../../hooks/useAuth";
import { PATH_DASHBOARD } from "../../routes/paths";

import { MHidden } from "../../components/@material-extend";
import AccountPopover from "./AccountPopover";

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 60;
const APPBAR_DESKTOP = 80;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const theme = useTheme();
  const location = useLocation();
  const isLight = theme.palette.mode === "light";
  const { isCollapse } = useCollapseDrawer();
  const { user } = useAuth();
  const navigate = useNavigate();

  const handlePriceCalculation = () => {
    navigate(PATH_DASHBOARD.pricecalculator.preview);
  };

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` },
        }),
      }}
    >
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: "text.primary" }}
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          {(location.pathname !== "/price-calculator/preview")  && (
            <Button
              size="medium"
              startIcon={
                <img
                  src="/static/icons/ic_invoice.svg"
                  alt="Price Calculator"
                  width={18}
                  height={18}
                  style={{
                    display: "block",
                    filter: "brightness(0) saturate(100%) invert(45%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(90%)",
                  }}
                />
              }
              onClick={handlePriceCalculation}
              sx={{
                background: "linear-gradient(135deg, #FFFFFF, #F7F7F7)",
                color: "#6f6f6f",
                border: "1px solid #E0E0E0",
                borderRadius: 10,
                px: 2.6,
                py: 0.9,
                fontSize: 13.5,
                fontWeight: 600,
                textTransform: "none",
                boxShadow: "none",
                transition: "all 0.25s ease",
                "&:hover": {
                  background: "linear-gradient(135deg, #FAFAFA, #F0F0F0)",
                  boxShadow: "none",
                },
              }}
            >
              Price Calculator
            </Button>
          )}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="subtitle1"
              color={isLight ? "#212b36" : "#ffffff"}
              noWrap
            >
              {user?.data?.name}
            </Typography>
          </Box>
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
